import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { operatorView } from '../constants/operators';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/phone-operators`;
const TTL = 10 * 60 * 1000;
let cache = { at: 0, promise: null };

const load = () => {
  if (!cache.promise || Date.now() - cache.at > TTL) {
    const promise = axios.get(API).then((r) => r.data?.items || []);
    cache = { at: Date.now(), promise };
    promise.catch(() => { if (cache.promise === promise) cache = { at: 0, promise: null }; });
  }
  return cache.promise;
};

export function usePhoneOperators() {
  const [state, setState] = useState({ operators: [], loading: true, error: false });
  useEffect(() => {
    let alive = true;
    load()
      .then((operators) => alive && setState({ operators, loading: false, error: false }))
      .catch(() => alive && setState({ operators: [], loading: false, error: true }));
    return () => { alive = false; };
  }, []);
  return state;
}

export function useOperatorView(item) {
  const { operators } = usePhoneOperators();
  return useMemo(() => operatorView(item, operators), [item, operators]);
}
